import React from 'react';
import PropTypes from 'prop-types';
import AbstractInput from '../AbstractInput';
import { InputMask } from '@react-input/mask';

const DEFAULT_REPLACEMENT = {
  '#': /\d/,
  a: /[A-Za-z]/,
  '*': /[A-Za-z0-9]/,
};

class MaskInput extends React.Component {
  static propTypes = {
    ...AbstractInput.propTypes,
    mask: PropTypes.string,
    replacement: PropTypes.object,
    showMask: PropTypes.bool,
    mutateValueBeforeCommit: PropTypes.func,
  };

  static defaultProps = {
    ...AbstractInput.defaultProps,
    showMask: false,
    replacement: DEFAULT_REPLACEMENT,
  };

  render() {
    const classNames = ['mask-input-field'];

    if (typeof this.props.className === 'string' && this.props.className.trim() !== '') {
      classNames.push(this.props.className);
    }

    const inputMask = (
      <InputMask
        id={this.props.id}
        mask={this.props.mask}
        showMask={this.props.showMask}
        replacement={this.props.replacement}
      />
    );

    return <AbstractInput {...this.props} className={classNames.join(' ')} inputElement={inputMask} />;
  }
}

export default MaskInput;
